import { atom } from 'jotai';

type DeleteSessionData = {
  sessionsToDelete: string[];
  selectedAll: boolean;
  onSessionsDeleted?: (deletedSessionIds: string[]) => void;
};

export const deleteSessionDataAtom = atom<DeleteSessionData | undefined>(undefined);
